import React, {useEffect, useState} from 'react'
import ShowPage from "@templates/page/ShowPage.template";
import useGql from "@modules/graphql/useGql";
import useAsyncMemo from "@hooks/useAsyncMemo";
import {SubscriptionFeeOutput} from "@src/gql-schema";
import {NoResourcesScreen} from "@pages/merchant/subscriptions/components/NoResources.screen";
import {NavbarBottomButtonWrapper} from "@components/button/NavbarBottomButton.wrapper";
import {useNavbarBottom} from "@components/navigation/NavbarBottom/NavbarBottom.context";
import {FeeTypePullover} from "@pages/merchant/subscriptions/pages/config/pages/fee/components/FeeType.pullover";
import {FeeList} from "@pages/merchant/subscriptions/pages/config/pages/fee/components/Fee.list";
import useParamId from "@hooks/useParamId";
import {__t} from "@config/i18n";

export function FeeIndexPage() {

    const gql = useGql()
    const subscriptionId = useParamId('subscriptionId');
    const navbarBottom = useNavbarBottom()

    const [refresh, setRefresh] = useState(true)

    /**
     *
     */
    const subscriptionName = useAsyncMemo(async () => {
        return await gql.GetSubscription({id: subscriptionId})
            .then(r => r.getSubscription.title)
    }, [subscriptionId], __t('subscription.config.title'))

    /**
     *
     */
    useEffect(() => {
        navbarBottom.children[1](
            <NavbarBottomButtonWrapper>
                <FeeTypePullover
                    subscriptionId={subscriptionId}
                    refreshState={[refresh, setRefresh]}
                />
            </NavbarBottomButtonWrapper>
        )
    }, [subscriptionId]);

    /**
     *
     */
    const fees: SubscriptionFeeOutput[] = useAsyncMemo(async () => {
        if (!refresh) {
            return fees
        }
        return await gql.GetSubscriptionFees({subscriptionId: subscriptionId ?? ''})
            .then(r => r.getSubscriptionFees)
            .finally(() => setRefresh(false))
    }, [subscriptionId, refresh], []);


    return (
        <ShowPage back={{
            title: subscriptionName,
            path: `/subscriptions/${subscriptionId}/config`
        }}>
            {fees.length === 0 && <NoResourcesScreen text={__t('fee.no_results')}/>}
            <FeeList fees={fees}/>
        </ShowPage>
    )
}